import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { BorderWidths, Colors, Space } from '../../types';

export const List: ComponentStyleConfig = {
  variants: {
    contentList: {
      item: {
        paddingY: Space.LG,
        borderBottomWidth: BorderWidths.XS,
        borderColor: Colors.BORDER_DEFAULT,
      },
    },
  },
};
